import type { PlacementMessage } from '../shared-placement-messages/types';

export const getFeatureId = (message: PlacementMessage): string | undefined =>
	(message as { featureId?: string }).featureId;
